import { inject, Provider } from '@angular/core';
import { Dialog } from '@angular/cdk/dialog';
import { TranslateService } from '@ngx-translate/core';
import { CABINET_STAFF_CLIENT_QR_PRINT } from '@nebalkon-workspace/cabinet-core';
import { NiimbotPrinterService } from '@nebalkon-workspace/niimbot-printer';
import { NotSystemNotificationService } from '@nebalkon-workspace/ui-kit';
import { printStaffClientQr } from './staff-client-qr-print.util';

export function provideStaffClientQrPrint(): Provider {
  return {
    provide: CABINET_STAFF_CLIENT_QR_PRINT,
    useFactory: () => {
      const printer = inject(NiimbotPrinterService);
      const translate = inject(TranslateService);
      const notification = inject(NotSystemNotificationService);
      const dialog = inject(Dialog);

      return (params: { userId: string; lastName?: string }) =>
        printStaffClientQr({
          userId: params.userId,
          lastName: params.lastName,
          printer,
          translate,
          notification,
          dialog,
        });
    },
  };
}
